module.exports = __webpack_public_path__ + "static/media/achievement-23.1c3d02f5.png";